import { useEffect, useState } from "react";
import API from "../../lib/api";

export function DbHealthCard() {
  const [db, setDb] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    API.get("/platform/system-status/database").then(({ data }) => setDb(data)).catch((e) => setErr(e.response?.data?.detail || "Couldn't read database stats"));
  }, []);

  return (
    <div className="rounded-lg border border-border bg-card p-3" data-testid="system-database">
      <div className="text-xs font-semibold mb-2">Database health <span className="font-normal text-muted-foreground">· refreshed every 5 min</span></div>
      {err && <p className="text-xs text-red-600">{err}</p>}
      {!db && !err && <p className="text-xs text-muted-foreground">Reading collection sizes…</p>}
      {db && (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-3">
            {[["Ping", `${db.ping_ms} ms`, "db-ping"], ["Data", `${db.data_mb} MB`, "db-data"], ["Storage + indexes", `${db.total_mb} MB`, "db-total"], ["Documents", (db.objects ?? 0).toLocaleString(), "db-objects"]].map(([l, v, id]) => (
              <div key={l} className="rounded bg-muted/40 p-2" data-testid={id}><div className="text-[10px] text-muted-foreground">{l}</div><div className="text-sm font-semibold tabular-nums">{v}</div></div>
            ))}
          </div>
          <div className="text-[11px] text-muted-foreground mb-1">{db.collections} collections · biggest first</div>
          <table className="w-full text-xs">
            <thead><tr className="text-left text-muted-foreground"><th className="py-1 font-medium">Collection</th><th className="py-1 font-medium text-right">Docs</th><th className="py-1 font-medium text-right">Data</th><th className="py-1 font-medium text-right">Indexes</th></tr></thead>
            <tbody>
              {db.top_collections.map((c) => (
                <tr key={c.name} className="border-t border-border/60" data-testid="db-collection-row">
                  <td className="py-1 font-mono">{c.name}</td><td className="py-1 text-right tabular-nums">{c.docs.toLocaleString()}</td>
                  <td className="py-1 text-right tabular-nums">{c.size_mb} MB</td><td className="py-1 text-right tabular-nums">{c.index_mb} MB · {c.indexes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
